import type { IBranding } from '../Types/Branding.types';
import { WaterOnboard } from './Onboard/OnboardBranding';
import { WaterThemeDefault } from './Themes/Water/WaterThemeDefault';
import { WaterThemes } from './WaterThemes';

const WaterBranding: IBranding = {
  BrandingName: 'BFF Apps',
  Onboard: WaterOnboard,
  Theme: {
    themes: WaterThemes,
    defaultLightTheme: 'water-light',
    defaultDarkTheme: 'water-dark',
    defaultCSSConfig: WaterThemeDefault(),
    enableSystemTheme: true,
    enablePersistence: true,
    injectCSSVariables: true,
    storageKey: 'ut-dashboard-theme',
  },
};

export { WaterBranding };
